import { render, staticRenderFns } from "./DontInsure.vue?vue&type=template&id=5099f7ef&scoped=true&"
import script from "./DontInsure.vue?vue&type=script&lang=js&"
export * from "./DontInsure.vue?vue&type=script&lang=js&"
import style0 from "./DontInsure.vue?vue&type=style&index=0&id=5099f7ef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5099f7ef",
  null
  
)

export default component.exports